import { AfterViewInit, Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridComponent, GroupSettingsModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SharedService } from 'src/app/services/shared.service';
import { CommonService } from '../common.service';
import { DataManager } from '@syncfusion/ej2-data';

@Component({
  selector: 'app-case-info-pop-up',
  templateUrl: './case-info-pop-up.component.html',
  styleUrls: ['./case-info-pop-up.component.scss']
})
export class CaseInfoPopUpComponent implements OnInit, AfterViewInit {
  caseInfo: any = {
    caseSpecimens: [{
      quantitativeResults: [],
      qualitativeResults: [],
    }]
  };
  insuranceInfo: any = []; 

  patientInfo: any = {};
  specimenInfo: any = {};
  caseTestDetails: any = [];
  pageSettings: PageSettingsModel;
  isCaseOrderInfo = false;

  noteList: any = [];
  quantitativeChildGrid: any;
  @ViewChild('quantitativeTestGrid') public quantitativeTestGrid: GridComponent;
  qualitativeChildGrid: any;
  @ViewChild('qualitativeTestGrid') public qualitativeTestGrid: GridComponent;

  @ViewChild('resultTemplate', { static: true }) public resultTemplate: any;
  @ViewChild('commentsTemplate', { static: true }) public commentsTemplate: any;
  @ViewChild('priorityTemplate', { static: true }) public priorityTemplate: any;
  @ViewChild('verifiedTemplate', { static: true }) public verifiedTemplate: any;
  @ViewChild('referenceTestTemplate', { static: true }) public referenceTestTemplate: any;

  searchCtrlForPriority = '';
  groupOptions: GroupSettingsModel;

  constructor(
    private dialogRef: MatDialogRef<CaseInfoPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
    @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this.pageSettings = this.sharedService.resetPageSettings();
    this.groupOptions = { showDropArea: false, columns: ['class'] };
    if (this.data && this.data.isCaseOrderInfo) {
      this.isCaseOrderInfo = this.data.isCaseOrderInfo;

      this.quantitativeChildGrid = {
        queryString: 'quantitativeId',
        allowResizing: true,
        load() {
          this.registeredTemplate = {};
        },
        columns: [
          { field: 'compound', headerText: 'Test', width: '60' },
          { headerText: 'Result', template: this.resultTemplate, width: '30' },
          { field: 'cutOff', headerText: 'Ref Range', width: '60' },
          { headerText: 'Comments', template: this.commentsTemplate, textAlign: 'Center', width: '30' },
          { headerText: 'Priority', template: this.priorityTemplate, width: '50' },
          { headerText: 'Verify', template: this.verifiedTemplate, textAlign: 'Center', width: '25' },
          { headerText: 'Reference Test', template: this.referenceTestTemplate, textAlign: 'Center', width: '35' },
        ]
      };

      this.qualitativeChildGrid = {
        queryString: 'qualitativeId',
        allowResizing: true,
        load() {
          this.registeredTemplate = {};
        },
        columns: [
          { field: 'compound', headerText: 'Test', width: '60' },
          { headerText: 'Result', template: this.resultTemplate, width: '30' },
          { field: 'cutOff', headerText: 'Ref Range', width: '60' },
          { headerText: 'Comments', template: this.commentsTemplate, textAlign: 'Center', width: '30' },
          { headerText: 'Priority', template: this.priorityTemplate, width: '50' },
          { headerText: 'Verify', template: this.verifiedTemplate, textAlign: 'Center', width: '25' },
          { headerText: 'Reference Test', template: this.referenceTestTemplate, textAlign: 'Center', width: '35' },
        ]
      };
    }
    this.getCaseInfoById();
  }

  ngAfterViewInit(): void {
    this.resultTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.resultTemplate.elementRef.nativeElement.propName = 'template';
    this.commentsTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.commentsTemplate.elementRef.nativeElement.propName = 'template';
    this.priorityTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.priorityTemplate.elementRef.nativeElement.propName = 'template';
    this.verifiedTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.verifiedTemplate.elementRef.nativeElement.propName = 'template';
    this.referenceTestTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.referenceTestTemplate.elementRef.nativeElement.propName = 'template';
  }

  getCaseInfoById() {
    this.commonService.getCaseInfoById(this.data.caseId, this.isCaseOrderInfo).subscribe(res => {
      if (res) {
        if (this.isCaseOrderInfo) {
          if (res.caseDrugs && res.caseDrugs.length > 0) {
            res.caseDrugsName = res.caseDrugs.map(m => m.drugName).join(',');
          }
          this.caseInfo = res;
          this.getPatientinfo();
          this.setQuantitativeQualitativeGrid();
        } else {
          if (res.caseInfo) { this.caseInfo = res.caseInfo; }
          if (res.specimenInfo) { this.specimenInfo = res.specimenInfo; }
          this.caseTestDetails = res.caseTestDetails || [];
          this.getInsuranceDetails();
        }
      }
    });
  }

  getInsuranceDetails() {
 /*    this.commonService.getPatientInsuranceByCaseId(this.data.caseId).subscribe(res => {
      if (res && res.length > 0) {
        res.forEach(element => {
          element.viewInsuranceType = element.insuranceDetail.insuranceType;
          element.viewPolicyid = element.insuranceDetail.policyid;
          element.viewFullName = element.insuranceDetail.lastNameOfInsured + ', ' + element.insuranceDetail.firstNameOfInsured;
          element.viewGuarantorName = element.insuranceDetail.guarantorName;
          element.viewNoInsurance = (element.insuranceDetail.noInsurance ? 'Yes' : 'No');
        });
        this.insuranceInfo = res;       }
    }); */
        this.commonService.getInsuranceDetailsByCaseInfo(this.data.caseId).subscribe(res => {
      if (res && res.length > 0) {
        res.forEach(element => {
          element.viewInsuranceType = element.insuranceType;
          element.viewPolicyid = element.policyid;
          element.viewFullName = element.lastNameOfInsured + ', ' + element.firstNameOfInsured;
          element.viewGuarantorName = element.guarantorName;
          element.viewNoInsurance = (element.noInsurance ? 'Yes' : 'No');
          element.companyName = element.insuranceCompanyName;
        });
        this.insuranceInfo = res;
      }
    });
  }

  getPatientinfo() {
    this.commonService.getPatientinfo(this.caseInfo.patientId).subscribe(res => {
      if (res) {
        this.patientInfo = res;
      }
    });
  }

  setQuantitativeQualitativeGrid() {
    setTimeout(() => {
      if (this.caseInfo.caseSpecimens[0].quantitativeResults.length > 0) {
        const childList = [];
        this.caseInfo.caseSpecimens[0].quantitativeResults.forEach(element => {
          element.quantitativeId = element.id;
          if (element.caseResults) {
            element.caseResults.forEach(child => {
              child.quantitativeId = element.id;
              if (child.concentration) { child.concentration = Number(child.concentration); }
              child.commentTooltip = 'External Comments : ' + (child.comments ? child.comments : '') + '\n' + 'Internal Comments : ' + (child.internalComments ? child.internalComments : '');
              childList.push(child);
            });
          }
        });
        this.quantitativeTestGrid.childGrid.dataSource = new DataManager(childList);
      }

      if (this.caseInfo.caseSpecimens[0].qualitativeResults.length > 0) {
        const childList = [];
        this.caseInfo.caseSpecimens[0].qualitativeResults.forEach(element => {
          element.qualitativeId = element.id;
          if (element.caseResults) {
            element.caseResults.forEach(child => {
              child.qualitativeId = element.id;
              if (child.concentration) { child.concentration = Number(child.concentration); }
              child.commentTooltip = 'External Comments : ' + (child.comments ? child.comments : '') + '\n' + 'Internal Comments : ' + (child.internalComments ? child.internalComments : '');
              childList.push(child);
            });
          }
        });
        this.qualitativeTestGrid.childGrid.dataSource = new DataManager(childList);
      }
    }, 100);
  }

  getCaseNotes() {
    this.commonService.getCaseNotes(this.data.caseId).subscribe(res => {
      if (res) {
        this.noteList = res;
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
